import { Definable, Maybe, Id } from '@vimeo/core/types/generic';

/**
 * Create DOM element name in provided prefix context.
 *
 * @param prefix - prefix for creation of unique dom name
 * @param parts - parts of newly generated name
 */
export function createDomName(prefix: string, ...parts: Array<Id>): string;
export function createDomName(prefix: Maybe<string>, ...parts: Array<Id>): undefined;
export function createDomName(prefix: Maybe<string>, ...parts: Array<Id>): Definable<string> {
  if (!prefix) {
    return undefined;
  }

  return parts.length ? `${prefix}-${parts.join('-')}` : prefix;
}
